<template>
  <v-container class="mt-5">
    <v-row class="controlled-font">
      <v-card width="100%">
        <app-card-header
          :text="siteText.ui.testResults"
          icon="mdi-receipt"
        ></app-card-header>
        <v-card-text class="mx-auto text-center">
          <v-row class="controlled-font">
            <v-col cols="12" sm="2">
              <div class="font-weight-bold pb-2">
                {{ siteText.ui.testType }}
              </div>
              {{ testAttemptDetails.testName }}
            </v-col>
            <v-col cols="12" sm="2" class="text-center mx-auto">
              <div class="font-weight-bold pb-2">
                {{ siteText.ui.totalQuestions }}
              </div>
              {{ testAttemptDetails.totalQuestions }}
            </v-col>
            <v-col cols="12" sm="2" class="text-center mx-auto">
              <div class="font-weight-bold pb-2">
                {{ siteText.ui.numberIncorrect }}
              </div>
              {{ testAttemptDetails.totalQuestionsIncorrect }}
            </v-col>
            <v-col cols="12" sm="2" class="text-center mx-auto">
              <div class="font-weight-bold pb-2">
                {{ siteText.ui.passingScore }}
              </div>
              {{ testAttemptDetails.passingScore }}
            </v-col>
            <v-col cols="12" sm="2" class="text-center mx-auto">
              <div class="font-weight-bold pb-2">
                {{ siteText.ui.numberCorrect }}
              </div>
              {{ testAttemptDetails.totalQuestionsCorrect }}
            </v-col>
            <v-col cols="12" sm="2" class="text-center mx-auto">
              <div class="font-weight-bold pb-2">
                {{ siteText.ui.result }}
              </div>
              <div
                class="controlled-font pb-2 text-center font-weight-bold"
                :class="resultColor(testAttemptDetails.result)"
              >
                {{
                  testAttemptDetails.result === "P"
                    ? siteText.ui.pass
                    : siteText.ui.fail
                }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-col cols="12" sm="3" class="text-left ml-n3 mt-2">
        <v-btn class="primary  controlled-font" @click="next()"
          >{{ siteText.ui.next }}
          <v-icon right>mdi-arrow-right-bold</v-icon></v-btn
        >
      </v-col>
      <v-col cols="12" sm="6"></v-col>
      <v-col cols="12" sm="3" class="mx-auto text-right mt-2">
        <v-checkbox
          v-model="viewAllQuestions"
          :label="siteText.ui.viewAllQuestions"
          class="controlled-font black--text viewall-checkbox"
          @click="page = 1"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <template>
        <div v-if="displayQuestionSummary">
          <v-data-table
            :headers="headers"
            :items="viewAllQuestions ? allQuestions : incorrectQuestions"
            :items-per-page="itemsPerPage"
            hide-default-footer
            hide-default-header
            fixed-header
            @page-count="pageCount = $event"
            :page.sync="page"
            class="controlled-font"
            height="600px"
          >
            <template #header="{ props }">
              <thead class="v-data-table-header">
                <tr>
                  <th
                    class="text-start primary white--text py-2 font-weight-regular"
                    role="col"
                    v-for="head in props.headers"
                    :key="head.text"
                    :style="getColumnWidth(head.value)"
                  >
                    <div>
                      {{ head.text }}
                    </div>
                  </th>
                </tr>
              </thead>
            </template>

            <template #[`item.questionData`]="{item}">
              <v-row>
                <v-col cols="12" md="9" class="controlled-font py-5 my-auto">
                  {{ item.questionText }}
                </v-col>
                <v-col cols="12" md="3" class="my-auto py-5">
                  <div style="width:100px" v-if="item.imageBlobPath">
                    <expandable-image
                      class="mx-auto rounded"
                      :src="image(item.imageBlobPath)"
                      :close-on-background-click="true"
                    >
                    </expandable-image>
                  </div>
                </v-col>
              </v-row>
            </template>
            <template #[`item.answers`]="{ item }">
              <div class="my-auto py-5">
                <div
                  v-for="a in item.answers"
                  :key="a.answerChoice"
                  class="controlled-font"
                >
                  {{ a.answerChoice }}.
                  {{
                    a.answerText
                      ? `${a.answerText[0].toUpperCase() +
                          a.answerText.slice(1)}`
                      : ""
                  }}
                </div>
              </div>
            </template>

            <template #[`item.selectedAnswer`]="{ item }">
              <span
                :class="
                  !item.answeredCorrect && item.selectedAnswer
                    ? 'red--text'
                    : ''
                "
                >{{ item.selectedAnswer ? item.selectedAnswer : "-" }}</span
              >
            </template>
          </v-data-table>
          <div class="mx-auto text-center">
            <v-row class="pt-3">
              <v-col cols="12" sm="3"></v-col>
              <v-col cols="12" sm="2">
                <v-btn
                  class="primary controlled-font"
                  @click="--page"
                  :disabled="page == 1"
                >
                  <v-icon left>mdi-arrow-left-bold</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="2"
                ><div class="controlled-font mx-auto my-auto pt-3">
                  {{
                    String.format(
                      siteText.ui.testReviewPagination,
                      page,
                      pageCount
                    )
                  }}
                </div></v-col
              >
              <v-col cols="12" sm="2">
                <v-btn
                  class="primary controlled-font"
                  @click="++page"
                  :disabled="page >= pageCount"
                >
                  <v-icon right>mdi-arrow-right-bold</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" sm="3"></v-col>
            </v-row>
          </div>
        </div>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import "../assets/css/app.css";

import appCardHeader from "../components/ui/CardHeader.vue";
import VueExpandableImage from "vue-expandable-image";
Vue.use(VueExpandableImage);
export default {
  components: {
    appCardHeader,
  },
  async mounted() {
    await this.getSummaryData();
  },
  data() {
    return {
      questionSummary: null,
      viewAllQuestions: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 4,
    };
  },
  methods: {
    ...mapActions([
      "getTestQuestionSummary",
      "SetPage",
      "setBusy",
      "clearBusyWithDelay",
    ]),
    image(imageBlobPath) {
      return imageBlobPath
        ? `${this.mediaUrl}${imageBlobPath}?${this.userSession.authToken.sasToken}`
        : "";
    },
    resultColor(result) {
      return result === "P" ? "green--text" : "red--text";
    },
    next() {
      this.SetPage(this.pages.TestScoreCard.name);
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    async getSummaryData() {
      this.setBusy();
      this.questionSummary = await this.getTestQuestionSummary();
      this.clearBusyWithDelay(750);
    },
    getColumnWidth(colName) {
      console.log(colName);
      let width = 5;
      switch (colName) {
        case "questionData":
          width = 40;
          break;
        case "answers":
          width = 40;
          break;
        default:
          width = 5;
      }
      return `width:${width}% !important`;
    },
  },
  computed: {
    ...mapGetters([
      "baseApiUrl",
      "testAttemptDetails",
      "siteText",
      "pages",
      "selectedLanguage",
      "userSession",
      "mediaUrl",
    ]),
    incorrectQuestions() {
      return this.questionSummary
        ? this.questionSummary.questions.filter((q) => {
            return q.selectedAnswer && q.answeredCorrect === false;
          })
        : null;
    },
    allQuestions() {
      return this.questionSummary ? this.questionSummary.questions : null;
    },
    buttonText() {
      return !this.viewAllQuestions ? "All" : "Incorrect";
    },
    headerText() {
      return !this.viewAllQuestions
        ? "Questions Answered Incorrectly"
        : "All Questions";
    },
    tableHeight() {
      const questions = this.viewAllQuestions
        ? this.allQuestions
        : this.incorrectQuestions;
      let tableHeight = questions.length * 150;
      tableHeight = tableHeight > 600 ? 600 : tableHeight;
      return tableHeight.toString() + "px";
    },
    questions() {
      const questions = this.viewAllQuestions
        ? this.allQuestions
        : this.incorrectQuestions;
      const formattedQuestions = questions.map((q) => {
        return {
          questionNumber: q.questionNumber,
          questionText: q.questionText,
          image: this.image(q.imageId),
          answers: q.answers.map((a) => {
            return a.answerChoice + ". " + a.answerText;
          }),
        };
      });

      return formattedQuestions;
    },
    displayQuestionSummary() {
      return (
        this.questionSummary &&
        ((this.incorrectQuestions &&
          this.incorrectQuestions.length > 0 &&
          !this.viewAllQuestions) ||
          this.viewAllQuestions)
      );
    },
    headers() {
      return [
        {
          text: this.siteText.ui.numberAbbreviation,
          sortable: false,
          value: "questionNumber",
          align: "center",
        },
        {
          text: "Source",
          value: "source",
          align: "center",
        },
        {
          text: this.siteText.ui.question,
          sortable: false,
          value: "questionData",
        },
        {
          text: this.siteText.ui.answers,
          sortable: false,
          value: "answers",
        },
        {
          text: this.siteText.ui.correctAnswer,
          sortable: false,
          value: "correctAnswer",
          align: "center",
        },
        {
          text: this.siteText.ui.selectedAnswer,
          sortable: false,
          value: "selectedAnswer",
          align: "center",
        },
      ];
    },
  },
  watch: {
    async selectedLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.getSummaryData();
      }
    },
  },
};
</script>

<style scoped>
.question-source {
  position: absolute;
  bottom: 0;
  left: 0;
}

.toggle-button {
  max-width: 50px;
  text-transform: none !important;
  font-weight: normal !important;
  padding: 0 !important;
  margin: 0 !important;
}

.toggle-button.v-btn--outlined {
  border: 1px white solid !important;
}
body .expandable-image.expanded {
  background: rgba(116, 116, 116, 0.8);
}

.answer-text {
  text-transform: unset;
}

.v-data-table {
  border: thin solid rgba(0, 0, 0, 0.12);
}

.custom-pagination /deep/ .v-pagination__navigation {
  height: 50px !important;
  width: 50px !important;
  border-radius: 2px !important;
}

.custom-pagination /deep/ .v-pagination__navigation .v-icon {
  font-size: 20pt !important;
}

.custom-pagination /deep/ .v-pagination__item {
  height: 50px !important;
  min-width: 50px !important;
  border-radius: 2px !important;
}

.black--text /deep/ label {
  color: black;
}

.viewall-checkbox /deep/ .v-icon.v-icon {
  font-size: 35px !important;
  color: black !important;
}
</style>
